import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

interface PopupBoxWrapperProps {
	children?: React.ReactNode;
}

const PopupBoxWrapper = ({ children }: PopupBoxWrapperProps) => {
	if (!__SERVER__) {
		return <Box xcss={popupBoxWrapperStyles}>{children}</Box>;
	}

	// Wraped children in <></> to avoid returning undefined
	return <>{children}</>;
};

const popupBoxWrapperStyles = xcss({
	color: 'color.text',
	height: '100%',
});

export default PopupBoxWrapper;
